export const POLLS_GROUP_NAME = 'registration'

export const REGISTRATION_POLLS = {
  NUMBER_OF_STAFFERS: 'registration_number_of_staffers',
  OTHER_APPS: 'registration_other_apps',
  BOOKING_ADVANCE: 'registration_booking_advance',
  BUSINESS_FOCUS: 'registration_business_focus',
}
